import type { ExpansionWatchStatus } from "@repo/game-admin"

/** Plain-language label of each status, shared by every screen that shows one. */
export const WATCH_STATUS_LABELS: Record<ExpansionWatchStatus, string> = {
	late: "Late",
	not_in_source: "Not in source yet",
	not_imported: "Not imported yet",
	in_staging: "Imported, not deployed",
	images_missing: "Images missing",
	ready: "Ready",
	to_review: "To review",
	ignored: "Ignored",
	rejected: "Rejected",
}

/**
 * Soft tints of each status, for the chips and the calendar cards: the states
 * that need someone stand out, ready and closed stay quiet.
 */
export const WATCH_STATUS_TONES: Record<ExpansionWatchStatus, string> = {
	late: "border-transparent bg-bad-soft text-bad",
	not_in_source: "border-transparent bg-warn-soft text-warn",
	not_imported: "border-transparent bg-warn-soft text-warn",
	in_staging: "border-transparent bg-info-soft text-info",
	images_missing: "border-transparent bg-info-soft text-info",
	ready: "border-transparent bg-ok-soft text-ok",
	to_review: "border-transparent bg-primary/14 text-primary-text",
	ignored: "border-transparent bg-foreground/8 text-muted-foreground",
	rejected: "border-transparent bg-foreground/8 text-muted-foreground",
}

/** Statuses shown as a quiet dot instead of a tinted tag. */
export const QUIET_WATCH_STATUSES: ReadonlySet<ExpansionWatchStatus> = new Set([
	"ready",
	"ignored",
	"rejected",
])

/**
 * Label of a watched expansion's status. An expansion in prod without any
 * card reads "In prod, no cards yet" rather than "Images missing".
 */
export function watchStatusLabel(row: {
	status: ExpansionWatchStatus
	prodCardCount?: number
}): string {
	if (row.status === "images_missing" && row.prodCardCount === 0) {
		return "In prod, no cards yet"
	}
	return WATCH_STATUS_LABELS[row.status]
}

/** Every status, in the order filters list them. */
export const WATCH_STATUSES = Object.keys(WATCH_STATUS_LABELS) as [
	ExpansionWatchStatus,
	...ExpansionWatchStatus[],
]
